import { useState, useEffect } from 'react';
import {Link, useNavigate, useLocation} from 'react-router'; 
import './Profile.css';
import TableView from '../meTable/TableView';
import {ToNotify} from 'fast_inon';
import {base} from '../Config/app'
import {Ts} from '../Config/switcher';
import { InOption } from '../Shared/InputControl';

const ProfileMain = ({lang, account, Login}) => {
  const T = (value, key='profile') => Ts(lang, key, value)
  //const [profile, Profile] = useState('hidden')

    const onProfile = (e) => {
      //alert("onProfile")
    if(account.connected) {
      const element = document.getElementById("ProfileItems")
      if(element) {
        if(element.style.visibility === 'hidden')
          element.style.visibility = 'visible'
        else
          element.style.visibility = 'hidden'
      }
    }
    else {
      Login(true)
    }
  }

  useEffect(()=>{
      let item = document.getElementById("meProfileName")
      if( item) {
          item.innerHTML = account.connected ? T('salaam') : T('login');
          item.title = item.innerHTML+" "+account.Name;
      }
      
      item = document.getElementById("meProfilePhoto")
      if(item) {
          item.src = account.connected ? `/App_Data/Accounts/${account.Id}/photo.png` : 'images/avatar.png'
          item.title = account.Name;
      }

  },[account, lang])

// MeR 260106
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <>
        <button id="meProfile" className='ActionButton'
          onClick={onProfile}>
            <img id="meProfilePhoto" src="images/avatar.png" title={T('salaam')} />
            <p id="meProfileName">Login</p>
        </button>

        <ProfileMenu lang={lang} account={account} />
    </>

  )
}

const onMouseLeave = (event) => {
  //event.currentTarget.blur();
  const element = document.getElementById("ProfileItems")
  if(element) {
    element.style.visibility = 'hidden'
  }
};

const ProfileMenu = ({lang, account}) => {

    useEffect(()=>{
    const element = document.getElementById("ProfileItems")
    if(element) {
      const lis = element.querySelectorAll('li')
      lis.forEach(li => {
        if (!li.onclick) {
          li.onclick = onMouseLeave
        }
      })
    }
  },[])

  const navigate = useNavigate();

  const T = (value, key='profile') => Ts(lang, key, value)

    useEffect(()=>{
      ["myName", "myEmail","myRole"].forEach(id => {
          const element = document.getElementById(id) 
          if(element) {
              //	alert(element.id)
              if(id==='myRole') {
                  element.value = account[id.substring(2)]
                  element.disabled = true
              }
              else {
                  element.innerText = account[id.substring(2)]
              }
          }
      });
  },[account, lang])

  const onLogout = (e) => {
      //alert('remove localStorage')
      let store = localStorage.getItem(base.name)
      if(store) {
        localStorage.removeItem(base.name)
        window.location.reload()
      }
  }

  const goTo = (id) => {
    // Navigate to home with the hash
    //alert(`goToContact`)
    navigate(`/#${id}`);
  };

  return (
    <div id="ProfileItems" style={{visibility:'hidden'}}>
      <ul>
          <li className="my" id="myName"></li>
          <li className="my" id="myEmail"></li>
          <li className="my" id="myRole">
            <InOption entity='myRole'
                  options={T('roles')} 
                  selected={account.Role} 
                  readOnly={true} 
            />
          </li>
      </ul>
      <div className="divider"></div>
      <ul>
        <li><Link to="/home">{T('home')}</Link></li>
        <li onClick={()=>goTo('services')}>{T('service')}</li>
        <li onClick={()=>goTo('articles')}>{T('article')}</li>
        <li><Link to="/salaat">{T('salaat')}</Link></li>
        <li><Link to="/english">{T('english')}</Link></li>
        <li><Link to="/setting">{T('setting')}</Link> </li>
        <li onClick={()=>{navigate("/#contact")}}>{T('contact')}</li>
      </ul>
      {account?.role==='Admin'?
        <ul>
          <div className="divider" style={{marginBottom:'0.5rem'}}></div>
          <li><Link to="/admin">{T('admin')}</Link></li>
        </ul>
      :null}
      <div className="divider"></div>
      <ul>
          <li style={{display:'block'}} onClick={onLogout}>{T('logout')}</li> 
      </ul>
    </div>
  )
}

const ProfileItems = ({lang, account, onEtat}) => {
  const node = {entity:'Profile', id:account.Id, parent:1}
  const [message, Message] = useState('')

    const T = (value, key='profile') => Ts(lang, key, value)
  
    const onCell = (item) => {
      //alert(`node=${item.Value}`)
      onEtat && onEtat(`node=${item.Value}`)
    }

return (

<div className="Home" id="MainContainer">

{ account?.connected ?  
  <div className='CollapseTab'> 
    <TableView request={`/member/${node.entity}/${node.id}`} node={node} onChange={onCell} />
  </div>
: <h2>{T('login')}</h2> }

<ToNotify 
    message={message}
    onClose={()=>{Message('')}}
/>

</div>
        )
}

export {ProfileMain, ProfileItems}
